module.exports = __webpack_public_path__ + "media/application/images/ecaas_certification-0a9429260d36b824a63ff0d7eceb0162.png";